import { FC } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { icons } from '../../icons/IconSet';

const UserLogoutBtn: FC = () => {
  const { handleLogout } = useAuth();

  return (
    <div
      tabIndex={-1}
      role="button"
      className="opacity-70 bg-transparent p-2 hover:bg-white rounded-[20%] hover:opacity-100 transition-all cursor-pointer"
      onClick={handleLogout}
      title='Log Out'
    >
      {icons('log-out', { height: '18px' })}
    </div>
  );
}

export default UserLogoutBtn;
